import { createFileRoute, redirect } from '@tanstack/react-router';

import { McpInfo } from '@/features/mcp-info';
import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/mcp-info/')({
  beforeLoad() {
    if (userStore.isInternalUser) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: McpInfo,
});
